import { UI, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Button, Text } from 'native-base';
import React from 'react';
import { Pressable } from 'react-native';

import { MasterSelection } from '../../../../../components/MasterSelection';
import { MasterProfile } from '../../../../../components/MasterSelection/MasterProfile';
import { OrderHistoryPeriodSelector } from '../OrderHistoryPeriodSelector';

import { orderHistoryTexts } from './constants';

export interface OrdersHistoryHeaderProps {
  onReturn: () => void;
  onRefresh: () => void;
  lastUpdated: string;
  isMobile: boolean;
}

export const OrdersHistoryHeader: React.FC<OrdersHistoryHeaderProps> = ({
  isMobile,
  lastUpdated,
  onRefresh,
  onReturn,
}) => {
  if (isMobile) {
    return (
      <VStack space={Spacing['stack.nano']}>
        <HStack justifyContent="space-between">
          <Button
            p={0}
            testID="return-button"
            size={'lg'}
            variant="textLink"
            leftIcon={
              <UI.Icon
                testId="return-button-icon"
                name={'ArrowLeft'}
                size="xxs"
                color={Color['neutral.black']}
              />
            }
            justifyContent="start"
            onPress={onReturn}
            _text={{
              color: Color['neutral.black'],
              textTransform: 'capitalize',
              pl: Spacing['inline.nano'],
              fontSize: Typography['fontsize.lg'],
            }}>
            {orderHistoryTexts.title}
          </Button>
          <MasterProfile isMobile />
        </HStack>
        <UI.Text variant="semibold" pt={Spacing['stack.xxxs']} fontSize={Typography['fontsize.lg']}>
          {orderHistoryTexts.containerTitle}
        </UI.Text>
        <UI.Text
          fontSize={Typography['fontsize.lg']}
          fontFamily={Typography['fontfamily.base.light']}>
          {orderHistoryTexts.description}
        </UI.Text>
        <MasterSelection
          hideMasterProfile
          selectContainerStyle={{ w: 'full' }}
          containerStyle={{ py: Spacing['stack.xxxs'] }}
        />
        <OrderHistoryPeriodSelector isMobile />
      </VStack>
    );
  }

  return (
    <VStack w="full" pt={Spacing['stack.xs']} space={Spacing['stack.xxs']}>
      <HStack justifyContent="space-between" alignItems="center">
        <HStack alignItems={'center'} space={Spacing['inline.xxxs']} w="45%">
          <UI.IconButton
            icon="ArrowLeft"
            testId="return-button"
            iconColor={Color['brand.tertiary.principal']}
            iconSize="xs"
            shadow={3}
            variant="link"
            onPress={onReturn}
          />
          <VStack space={Spacing['inset.nano']} w="90%">
            <UI.Heading testId="qa" size="h2">
              {orderHistoryTexts.title}
            </UI.Heading>
            <UI.Text color="neutral.dark" variant="regular" fontSize={Typography['fontsize.md']}>
              {orderHistoryTexts.description}
            </UI.Text>
          </VStack>
        </HStack>

        <MasterSelection />
      </HStack>

      <HStack justifyContent="space-between">
        <OrderHistoryPeriodSelector />
        <HStack space={Spacing['inline.nano']} alignItems="center">
          <Text
            color={Color['neutral.medium']}
            variant="regular"
            fontSize={Typography['fontsize.xs']}>
            {lastUpdated}
          </Text>
          <Pressable testID={'refresh-button'} onPress={onRefresh}>
            <HStack space={1} alignItems={'center'} justifyContent={'center'}>
              <UI.Text
                textTransform="uppercase"
                color={'brand.tertiary.principal'}
                variant="semibold"
                fontSize={Typography['fontsize.xs']}>
                Atualizar
              </UI.Text>
              <UI.Icon name="Refresh" size="xxxs" color={Color['brand.tertiary.principal']} />
            </HStack>
          </Pressable>
        </HStack>
      </HStack>
    </VStack>
  );
};
